import { NgModule } from "@angular/core";

const DIRECTIVES = [];

@NgModule({
	imports: [],
	exports: [...DIRECTIVES],
	declarations: [...DIRECTIVES]
})
export class DirectivesModule {
}
